import { render, staticRenderFns } from "./ViewerComponent.vue?vue&type=template&id=7de9feba&"
import script from "./ViewerComponent.vue?vue&type=script&lang=js&"
export * from "./ViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ViewerComponent.vue?vue&type=style&index=0&id=7de9feba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports